import { Dispatch } from 'redux';
import {
  APPEARANCE_SETTINGS_GET_IN_PROGRESS,
  APPEARANCE_SETTINGS_GET_SUCCESS,
  APPEARANCE_SETTINGS_GET_FAILED,
} from 'store/actionTypes';
import { AppearanceSettingsData } from 'interfaces/redux';
import apiClient from 'utils/apiClient';
import {config} from 'config/config';

type AppearanceSettingsResponse = {
  theme?: unknown;
  [key: string]: unknown;
};

const normalizeAppearanceSettings = (value: unknown): unknown => {
  if (!value || typeof value !== 'object') return value;

  const settings = value as AppearanceSettingsResponse;
  const theme = settings.theme;

  if (typeof theme === 'string') {
    try {
      return { ...settings, theme: JSON.parse(theme) as unknown };
    } catch {
      return settings;
    }
  }

  return settings;
};

export const loadAppearanceSettings = (data: AppearanceSettingsData) => (async (dispatch: Dispatch) => {
  dispatch({ type: APPEARANCE_SETTINGS_GET_IN_PROGRESS });

  try {
    let current;
    if (!sessionStorage.getItem('current')) {
      const response = await apiClient.request(config.api.routes.backend.appearanceSettings.current, data, 'POST');

      const normalized = normalizeAppearanceSettings(response);
      sessionStorage.setItem('current', JSON.stringify(normalized));
      current = normalized;
    } else {
      const currentData: string | null = sessionStorage.getItem('current');
      current = currentData ? normalizeAppearanceSettings(JSON.parse(currentData)) : null;
    }

    dispatch({
      type: APPEARANCE_SETTINGS_GET_SUCCESS,
      payload: current,
    });
  } catch (error) {
    dispatch({
      type: APPEARANCE_SETTINGS_GET_FAILED,
    });
  }
});
